import loanFormModel from '../../form_models/loanFormModel';
import { defaultBorrowerLegalName } from '../../../../../../../components/loan_application/form_models/constants';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { MonetizeTaxCreditCheckRuleset } from '../../business/ruleset';
import { RulesetResult } from '../../business/rules';

const {
  formField: { monetizeTaxCreditCheck },
} = loanFormModel;

export class MonetizeTaxCreditCheckValidation implements ValidationSchema {
  public name: string = monetizeTaxCreditCheck.name;
  public label: string = monetizeTaxCreditCheck.getLabel(
    defaultBorrowerLegalName
  );

  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;
  public ruleset = MonetizeTaxCreditCheckRuleset;

  public when(schema: any, context: any, result: RulesetResult) {
    const required = !!(result & RulesetResult.REQUIRED);
    if (required) return schema.required('This field is required');

    return schema;
  }
}
export default new Validation(new MonetizeTaxCreditCheckValidation());
